var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedVoucherIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.877 14.877C14.3264 14.4275 15.0503 14.4275 15.4998 14.877L16.8249 13.5519C17.0584 13.3184 17.0584 12.9448 16.8249 12.7171L9.28289 5.17512C9.04939 4.94163 8.6758 4.94163 8.44814 5.17512L7.12304 6.50022C7.57252 6.94971 7.57252 7.67355 7.12304 8.12304C6.67355 8.57252 5.94971 8.57252 5.50022 8.12304L4.17512 9.44814C3.94163 9.68163 3.94163 10.0552 4.17512 10.2829L11.7171 17.8249C11.9506 18.0584 12.3242 18.0584 12.5519 17.8249L13.877 16.4998C13.4275 16.0503 13.4275 15.3264 13.877 14.877Z",
    fill: "white",
    stroke: "#E61B00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.5H12",
    stroke: "#E61B00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedVoucherIcon);
export default __webpack_public_path__ + "static/media/red_voucher_icon.c621b6eb55cda9fd44eb142ea6953b28.svg";
export { ForwardRef as ReactComponent };